import { fromJS } from "immutable";

export const initialState = {
	app: fromJS({})
};
